import { useGetIdentity } from "@refinedev/core";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SSOLoginPage } from "../auth/SSOLogin";

export const EntryPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { data: user } = useGetIdentity();
  const navigate = useNavigate();
  const instanceId = searchParams.get("instance");
  const callbackURL = searchParams.get("callbackURL");
  const originalURL = searchParams.get("originalURL");
  if (location.pathname === "/login-sso") {
    if (user && user.instances && user.instances.includes(instanceId)) {
      window.location.href = `/api/v1/um/login/idToken?refresh=true&target=${callbackURL}&redirect_to=${originalURL}`;
      return <div>Redirecting...</div>;
    } else {
      return <SSOLoginPage mode="noValidRole" />;
    }
  } else {
    navigate("/");
  }
};
